import React, {useContext, useEffect} from 'react'
import { Form, InputNumber } from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemParity = ({rowId}) => {
    const [form] = Form.useForm()
    const { rowData } = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    useEffect(() => {
        form.setFieldsValue({
            parity: rowState[rowId].parity
        })
    }, [])

    const handleParityChange = (list) => {
        let mockRows = Object.assign({}, rowState)
        mockRows[rowId].parity = list.parity
        setRowState(mockRows)
    }


    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 24}}
            >
                <Form.Item
                    name={'parity'}
                >
                    <InputNumber onChange={() => handleParityChange(form.getFieldsValue())}  step={0.1}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeItemParity